import { useJsonResource } from '../hooks/use-json-resource';

export const useOpenAPISpec = (urlVersion: string | undefined) => {
  const { loading, error, data } = useJsonResource<Record<string, unknown>>(urlVersion, 'openapi.json');
  return { loading, error, selectedSpec: data };
};
